var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTextUppercase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 3h-3a1 1 0 0 0-1 1v15.25a1 1 0 0 0 1 1h3.875a4.875 4.875 0 0 0 2.44-9.097A4.75 4.75 0 0 0 18 3Zm0 7.5h-2V5h2a2.75 2.75 0 1 1 0 5.5Zm-2 7.75V12.5h2.875a2.875 2.875 0 0 1 0 5.75H16ZM7.257 3a1 1 0 0 1 .934.66l5.5 15.25a1 1 0 0 1-1.881.68L10.515 16h-6.72l-1.359 3.603a1 1 0 0 1-1.871-.706l5.75-15.25A1 1 0 0 1 7.257 3ZM4.55 14h5.245L7.229 6.89 4.55 14Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTextUppercase);
export default __webpack_public_path__ + "static/media/ic-text-uppercase.a0c04cfdb809f5450e890f00dd21080c.svg";
export { ForwardRef as ReactComponent };